import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/global.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async"; //for page titles
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: process.env.REACT_APP_DSN,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1.0, // Adjust this value (0.0 to 1.0) for performance monitoring
    environment: process.env.NODE_ENV, // Helps distinguish between production and development errors
  });
}


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <HelmetProvider>
      <App />
    </HelmetProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
